import { render, staticRenderFns } from "./TkHotelReviewList.vue?vue&type=template&id=66149245&scoped=true&"
import script from "./TkHotelReviewList.vue?vue&type=script&lang=js&"
export * from "./TkHotelReviewList.vue?vue&type=script&lang=js&"
import style0 from "./TkHotelReviewList.vue?vue&type=style&index=0&id=66149245&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66149245",
  null
  
)

export default component.exports